export default __webpack_public_path__ + "static/media/reliability.106e0d8e.svg";